import React from 'react'
import PropTypes from 'prop-types'
import { Card, Row, Col, Badge } from 'react-bootstrap'
import { toCurrency } from '../../../../../../../utils/helpers/index.js'
import { getEvaluationVariant } from './TaskItemCard.jsx'

export const ProjectSummaryCard = ({ summary }) => {
    const globalStatusVariant = getEvaluationVariant(summary.status.label)
    const percentVariant = summary.percent > 100 ? 'danger' : 'primary'

    return (
        <Card className="mb-4 mt-5 p-3 border-primary">
            <Card.Body>
                <h4 className="text-primary fw-bold mb-4 border-bottom pb-2">
                    Podsumowanie Projektu
                </h4>
                <Row className="text-center">
                    <Col md={3} className="mb-3 mb-md-0 border-end">
                        <div className="text-muted small text-uppercase">Okres realizacji</div>
                        <div className="fw-bold mt-1 text-dark">
                            <i className="bi bi-calendar-range me-2"></i>
                            <Badge bg={'primary'} className="fs-5 p-2">
                                {summary.range}
                            </Badge>
                        </div>
                    </Col>

                    <Col md={2} className="mb-3 mb-md-0 border-end">
                        <div className="text-muted small text-uppercase">
                            Planowany budżet [ZŁ]
                        </div>
                        <div className="fw-bold mt-1">
                            <Badge bg={'primary'} className="fs-5 p-2">
                                {toCurrency(summary.totalPlan)}
                            </Badge>
                        </div>
                    </Col>

                    <Col md={2} className="mb-3 mb-md-0 border-end">
                        <div className="text-muted small text-uppercase">
                            Suma Wydatkowania ogółem [ZŁ]
                        </div>
                        <div className="fw-bold mt-1">
                            <Badge bg={'primary'} className="fs-5 p-2">
                                {toCurrency(summary.totalSpent)}
                            </Badge>
                        </div>
                    </Col>

                    <Col md={2} className="mb-3 mb-md-0 border-end">
                        <div className="text-muted small text-uppercase">
                            % Wydatkowania ogółem
                        </div>
                        <div className="fw-bold mt-1">
                            <Badge bg={percentVariant} className="fs-5 p-2">
                                {summary.percent.toFixed(2)}%
                            </Badge>
                        </div>
                    </Col>

                    <Col md={3}>
                        <div className="text-muted small text-uppercase">
                            Ocena Globalna Projektu
                        </div>
                        <div className="fw-bold mt-1">
                            <Badge
                                bg={globalStatusVariant}
                                className="fs-5 p-2 shadow-sm"
                            >
                                {summary.status.label}
                            </Badge>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

ProjectSummaryCard.propTypes = {
    summary: PropTypes.shape({
        totalPlan: PropTypes.number.isRequired,
        totalSpent: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
        range: PropTypes.string.isRequired,
        status: PropTypes.shape({
            label: PropTypes.string.isRequired,
            variant: PropTypes.string,
        }).isRequired,
    }).isRequired,
}

export default ProjectSummaryCard
